export const appConfig = (window as any).config as AppConfig;